<p class="text-surface-500 mb-4">We're always working to improve Homey and would love to hear your feedback. What's working well? What could be better? Any ideas for improvement? If you need help or have a question, please visit the Support tab instead.</p>

<homey-custom-form submitButtonLabel="Send feedback" [formGroup]="form" [submitFunction]="submit" buttonSize="small">
  <p-floatlabel variant="on" class="mb-2">
    <textarea
      pTextarea
      id="feedback-message"
      formControlName="message"
      rows="8"
      class="w-full resize-none"
    ></textarea>
    <label for="feedback-message">Your feedback</label>
  </p-floatlabel>
  <p-button additionalButtons size="small" severity="secondary" label="Cancel" class="ml-auto" (onClick)="onClose()"/>
</homey-custom-form>
